import React from 'react';
import { Box, BoxProps } from '@material-ui/core';
import { FormProps, UiSchema, withTheme } from '@rjsf/core';
import FilledInputWidget from './FilledInputWidget';
import FilledTextAreaWidget from './FilledTextAreaWidget';
import FieldTemplate from './FieldTemplate';
import DateWidget from './DateWidget';
import DateTimeWidget from './DateTimeWidget';
import CheckboxWidget from './CheckboxWidget';
import SelectWidget from './SelectWidget';

const ThemedForm = withTheme({
  FieldTemplate,
  widgets: {
    TextareaWidget: FilledTextAreaWidget,
    TextWidget: FilledInputWidget,
    DateWidget,
    DateTimeWidget,
    SelectWidget,
    CheckboxWidget,
  },
});

interface RJSFProps extends FormProps<any> {
  sx?: BoxProps['sx'];
  readOnly?: boolean;
}

/**
 * Renders a RJSF component
 * @param FormProps - accepts all props of type FormProps
 * @param sx - styles to apply to a MUI Box that wraps the html form component
 * @param readOnly - whether we should set all the widgets to readonly state
 */
const RJSF: React.FC<RJSFProps> = ({ sx, readOnly = false, uiSchema, ...other }: RJSFProps) => {
  const modifiedUiSchema: UiSchema = { 'ui:readonly': readOnly, ...uiSchema };

  return (
    <Box
      sx={{
        '& fieldset': {
          borderWidth: 0,
          m: 0,
          p: 0,
          '& > legend': {
            fontWeight: 500,
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
            letterSpacing: '0.009rem',
          },
        },
        '& .RJSF-width-48-percent': { width: '48%' },
        '& .RJSF-float-right': { float: 'right' },
        ...sx,
      }}
      data-testid="RJSF"
    >
      <ThemedForm {...other} uiSchema={modifiedUiSchema} />
    </Box>
  );
};

export default RJSF;
